import { render, staticRenderFns } from "./DHSchemaInfo.vue?vue&type=template&id=3a0e72e9&scoped=true"
import script from "./DHSchemaInfo.vue?vue&type=script&lang=js"
export * from "./DHSchemaInfo.vue?vue&type=script&lang=js"
import style0 from "./DHSchemaInfo.vue?vue&type=style&index=0&id=3a0e72e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e72e9",
  null
  
)

export default component.exports